import React from 'react';
import style from "./index.module.css";
import {Breadcrumb, Divider} from "antd";
import CertificateNavModule from "../../components/certificateNavModule";
import noDataIcon from "../../assets/icons/noData.svg";

const SixthPage = () => {
    const baseItem = [
        {
            title: <div>首页</div>,
        },
        {
            title: "客户服务",
        },
    ];

    return (
        <div className={style.pageContainer}>
            <Breadcrumb
                items={baseItem}
            />

            <div className={style.content}>
                <div className={style.leftNavBar}>
                    <CertificateNavModule/>
                </div>

                <div className={style.rightMainContainer}>
                    <div>
                        <div className={style.pageTitle}>客户服务</div>
                        <Divider style={{padding: '0 30px', borderColor: '#043554'}}>INFORMATION CENTER</Divider>
                    </div>


                    <div style={{display: "grid", placeItems: 'center'}}>
                        <img src={noDataIcon} height={200} width={300} alt=""/>
                        <div>暂无内容</div>
                    </div>

                </div>
            </div>

        </div>

    );
};

export default SixthPage;